export interface RuntimeConfig {
  apiUrl: string;
  supabaseUrl: string;
  supabasePublishableKey: string;
  appName: string;
}

const runtime = window.__WINBOX_CONFIG__ ?? {};

export const appConfig: RuntimeConfig = {
  apiUrl:
    runtime.apiUrl ||
    import.meta.env.VITE_API_URL ||
    "http://localhost:4000/api",
  supabaseUrl: runtime.supabaseUrl || import.meta.env.VITE_SUPABASE_URL || "",
  supabasePublishableKey:
    runtime.supabasePublishableKey ||
    runtime.supabaseAnonKey ||
    import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY ||
    import.meta.env.VITE_SUPABASE_ANON_KEY ||
    "",
  appName: runtime.appName || import.meta.env.VITE_APP_NAME || "WINBOX WorkHub",
};
